var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33369 12.0557C11.4605 8.10403 17.5477 5.49775 20.5926 4.23946C29.2867 0.646589 31.0946 0.0213987 32.2732 0.000295261C32.5334 -0.00498061 33.1121 0.0583306 33.4864 0.361693C33.8023 0.617573 33.8899 0.963142 33.9324 1.20319C33.9749 1.44325 34.0253 1.99721 33.9855 2.4272C33.5156 7.34695 31.4742 19.2862 30.4388 24.7969C30.0008 27.1288 29.1354 27.9096 28.2992 27.9861C26.4807 28.1523 25.1003 26.7912 23.3402 25.6437C20.5847 23.8499 19.0264 22.7314 16.3531 20.9798C13.263 18.9565 15.2647 17.8433 17.0274 16.0257C17.4893 15.5509 25.4985 8.30979 25.6551 7.65294C25.6737 7.57117 25.6923 7.26517 25.5091 7.10162C25.3259 6.93806 25.0552 6.9961 24.8614 7.03831C24.5853 7.10162 20.1838 9.99279 11.6543 15.7118C10.4039 16.5639 9.27304 16.9807 8.25895 16.9569C7.14133 16.9332 4.99105 16.3291 3.39292 15.8121C1.43111 15.179 -0.127188 14.844 0.00820129 13.7677C0.0798778 13.2084 0.855035 12.6334 2.33635 12.0477L2.33369 12.0557Z",
    fill: "#073AE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTg);
export default __webpack_public_path__ + "static/media/social-tg.38247166e814da8e025f562de9c97811.svg";
export { ForwardRef as ReactComponent };